import Controller from '@ember/controller';
import { ApiCredentialType } from 'cio/utils/api-key-type-interface';

export default class ApiCredentialsController extends Controller {
  queryParams = ['keyType'];
  keyType: ApiCredentialType = ApiCredentialType.Tracking;
}
